const BANNERS = [
    {
        url: '/posters/gaming',
        name: 'Gaming',
        image: 'https://displate.com/img/menu_static/collections/gaming.jpg',
    },
    {
        url: '/posters/movies',
        name: 'Movies',
        image: 'https://displate.com/img/menu_static/collections/movies.jpg',
    },
    {
        url: '/posters/japanese',
        name: 'Japanese & Asian',
        image: 'https://displate.com/img/menu_static/collections/asian.jpg',
    },
    {
        url: '/posters/fantasy',
        name: 'Fantasy',
        image: 'https://assets-static-prod.displate.com/next-assets/public/images/header/fantasy.jpg',
    },
];
export default BANNERS;
//# sourceMappingURL=banners.js.map